import { ClockIcon, QuestionMarkCircleIcon } from "@heroicons/react/20/solid"
import { ProjectStatus } from "../helpers/getProjectStatus"

interface Props {
    status: string
}

export function ProjectStatusIndicator({ status }: Props) {
    if (status === ProjectStatus.Analysing) {
        return <ClockIcon className="ml-1 inline-block size-5 align-text-top text-orange-400" />
    } else if (status === ProjectStatus.WaitingForBusinessQuestion) {
        return <QuestionMarkCircleIcon className="ml-1 inline-block size-5 align-text-top text-orange-400" />
    }

    return <></>
}
